var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2605 15.5431C13.478 15.5748 13.6905 15.5906 13.8971 15.5906C15.7538 15.5906 17.1496 14.3289 17.4563 12.2931L18.2555 6.94313C18.5955 4.6798 17.3655 2.93897 15.1946 2.61147L11.486 2.05322L11.485 2.05272L11.484 2.05222C9.30929 1.73587 7.6279 3.03834 7.28876 5.3023L6.48876 10.6523C6.14876 12.9156 7.37959 14.6573 9.55046 14.9839L13.2605 15.5431ZM14.5715 8.36776C14.6015 8.37192 14.6315 8.37442 14.6615 8.37442C14.9674 8.37442 15.234 8.14942 15.279 7.83858C15.329 7.49692 15.0924 7.18025 14.7499 7.13108L11.004 6.58858C10.6574 6.53942 10.3457 6.77692 10.2965 7.11775C10.2465 7.45942 10.4832 7.77608 10.8249 7.82608L14.5715 8.36776ZM12.6432 11.1511C12.6732 11.1553 12.7032 11.1578 12.7332 11.1578C13.039 11.1578 13.3057 10.9336 13.3507 10.6219C13.4007 10.2803 13.164 9.96359 12.8215 9.91442L10.5749 9.58859C10.2349 9.54276 9.91571 9.77526 9.86654 10.1178C9.81738 10.4594 10.054 10.7761 10.3957 10.8253L12.6432 11.1511Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5212 16.5449L9.36333 16.2206C6.49913 15.7881 4.80912 13.4222 5.25246 10.4664L6.05246 5.11724C6.06676 5.02174 5.97584 4.94264 5.8841 4.97278L4.68718 5.36603C3.69135 5.6927 2.94301 6.30603 2.52385 7.1402C2.08551 8.0102 2.04301 9.08267 2.40135 10.1585L4.08885 15.2927C4.65718 17.0102 5.95051 17.9952 7.49468 17.9952C7.90468 17.9952 8.33218 17.926 8.76883 17.7818L11.5484 16.8681C11.7152 16.8132 11.6948 16.5711 11.5212 16.5449Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/Cards.7f6b83202ce6ffbc2c2a942cb52539ce.svg";
export { ForwardRef as ReactComponent };